// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const pt = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Início',
    search: 'Pesquisar',
    login: 'Entrar',
    register: 'Registar',
    dashboard: 'Painel',
    reservas: 'Reservas',
    equipo: 'Equipa',
    logout: 'Sair',
    legal: 'Legal',
    legalNotice: 'Aviso legal',
    privacy: 'Política de privacidade',
    cookies: 'Política de cookies',
    terms: 'Termos e condições',
    clientes: 'Clientes',
  },
  legal: {
    noticeTitle: 'Aviso legal',
    noticeBody:
      'Em cumprimento da Lei espanhola 34/2002 (LSSI-CE), informa-se de que este site é da titularidade da bitutravel. E-mail de contacto: legal@bitutravel.app. A utilização do site atribui a condição de utilizador e implica a aceitação das presentes condições.',
    privacyTitle: 'Política de privacidade',
    privacyBody:
      'Tratamos os seus dados apenas para gerir a sua conta, as suas reservas e a faturação exigida pela legislação espanhola (RGPD e LOPDGDD). Nunca cedemos os seus dados a terceiros para fins comerciais. Pode exercer os seus direitos de acesso, retificação, eliminação e portabilidade escrevendo para privacy@bitutravel.app.',
    cookiesTitle: 'Política de cookies',
    cookiesBody:
      'A bitutravel utiliza apenas cookies técnicas estritamente necessárias: a sessão de autenticação e a preferência de idioma. Não utilizamos cookies publicitários nem de rastreio de terceiros.',
    termsTitle: 'Termos e condições',
    termsBody:
      'As reservas são solicitadas através da plataforma e ficam sujeitas à aprovação do proprietário e à política de cancelamento escolhida. A faturação corporativa é emitida de acordo com a legislação espanhola (IVA e IRPF aplicáveis). A bitutravel atua como intermediária entre a empresa solicitante e o proprietário do alojamento. Os preços apresentados não incluem IVA (21%), acrescido ao total da reserva.',
  },
  landing: {
    heroTitle: 'Alojamento corporativo sem complicações',
    heroSubtitle:
      'Encontre alojamento de qualidade de média duração para as suas equipas em toda a Espanha. Com a confiança de empresas líderes.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Hóspedes',
    search: 'Pesquisar',
    featured: 'Estadias em destaque',
    featuredIn: 'Em destaque em {{city}}',
    guestsValue: '{{count}} hóspedes',
    where: 'Onde',
    when: 'Quando',
    who: 'Quem',
    searchDestinations: 'Pesquisar destinos',
    addDates: 'Adicionar datas',
    addGuests: 'Adicionar hóspedes',
    howItWorks: 'Como funciona',
    step1Title: 'Pesquise',
    step1Desc: 'Explore alojamentos verificados nas principais cidades de Espanha.',
    step2Title: 'Reserve',
    step2Desc: 'Reserve estadias de média duração para as suas equipas com condições corporativas.',
    step3Title: 'Mude-se',
    step3Desc: 'A sua equipa instala-se. Nós tratamos da fatura e da nota de despesas do viajante.',
    perNight: '/ noite',
    perNightPlusIva: '/ noite + IVA',
    comingSoon: 'Brevemente',
    trustedBy: 'Já confiam em nós',
    testimonialsTitle: 'O que dizem os nossos clientes',
    review1Text: 'Desde que uso a bitutravel, as faturas chegam automaticamente e simplifica todo o processo.',
    review1Author: 'María López',
    review1Role: 'Responsável de mobilidade, consultoria tecnológica',
    review2Text: 'Gerimos o alojamento de toda a equipa numa só plataforma. A poupança de tempo e custos é evidente.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Diretor de operações, empresa de engenharia',
    review3Text: 'A faturação empresarial e a nota de despesas de viagem vêm prontas para auditoria. Zero trabalho administrativo.',
    review3Author: 'Elena García',
    review3Role: 'Responsável financeiro, multinacional',
    illustrativeImage: 'imagem ilustrativa',
  },
  search: {
    allSpain: 'Toda a Espanha',
    allDistricts: 'Todos os distritos',
    viewAllResults: 'Ver todos os resultados',
    results: 'resultados',
    sort: 'Ordenar',
    sortPriceAsc: 'Preço: do menor para o maior',
    sortPriceDesc: 'Preço: do maior para o menor',
    noResults: 'Não há alojamentos nesta zona.',
    noResultsForFilters: 'Não há alojamentos para estes filtros. Tente remover as datas ou alterar os filtros.',
    clearFilters: 'Remover filtros',
    areaPlaceholder: 'Bairro, zona ou código postal',
    showMap: 'Mapa',
    showMore: 'Ver mais',
    backToTop: 'Voltar ao topo',
    typeAll: 'Tudo',
    placeEntire: 'Apartamento inteiro',
    placeRoom: 'Quarto privativo',
    placeHotel: 'Hotel',
    dates: 'Datas',
    sortRecommended: 'Recomendado',
    size: 'Quartos',
    sizeAny: 'Qualquer',
    sizeSingle: '1 quarto',
    sizeDouble: '2 quartos',
    size3plus: '3+ quartos',
    rooms: 'Quartos',
    units: 'Unidades',
    grouping: 'Agrupar',
    groupAny: 'Qualquer',
    typeInCity: '{{type}} em {{city}}',
    forNights: 'por {{count}} noites',
    filters: 'Filtros',
    groupSameBuilding: 'Mesmo edifício',
    groupSameArea: 'Zona próxima',
    groupSameCategory: 'Mesma categoria',
    roomsValue: '{{count}} qts.',
    unitsValue: '{{count}} un.',
    groupResults: 'grupos',
    fromPrice: 'a partir de {{price}}',
    unitsInBuilding: '{{count}} unidades neste edifício',
    groupUnits: 'unidades',
    sameBuilding: 'Mesmo edifício',
    sameArea: 'Zona próxima',
    sameCategory: 'Mesma categoria',
    anyGroup: 'Unidades',
    priceFrom: 'desde',
    bookAll: 'Reservar as {{count}}',
    playTour: 'Reproduzir tour',
    approxMapNote: 'As localizações são aproximadas. Entre para ver a localização exata.',
    pauseTour: 'Pausar tour',
    bookAllTitle: 'Reservar o grupo',
    bookAllDesc: 'Reserve as {{count}} unidades como um único conjunto.',
    bookAllSummary: '{{count}} unidades · {{nights}} noites',
    bookAllSomeFailed: 'Algumas unidades não puderam ser reservadas.',
    bookAllDone: 'Conjunto reservado ({{ok}}/{{count}}).',
    structRoomIn: 'Quarto em {{building}}',
    structRoomsSameApartment: '{{count}} quartos no mesmo apartamento',
    structRoomsSameBuilding: '{{count}} quartos no mesmo edifício',
    structApartmentsSameBuilding: '{{count}} apartamentos no mesmo edifício',
    structStaysSameArea: '{{count}} estadias na mesma zona',
    structStaysSameCategory: '{{count}} estadias · {{category}}',
    structUnits: '{{count}} unidades',
    specFull: '{{guests}} hóspedes · {{bedrooms}} quartos · {{baths}} banheiros',
    specShort: '{{bedrooms}} dorm. · {{baths}} banho',
  },
  detail: {
    guests: 'hóspedes',
    bedrooms: 'quartos',
    bathrooms: 'casas de banho',
    amenities: 'Comodidades',
    location: 'Localização',
    nights: 'noites',
    cleaningFee: 'Limpeza',
    total: 'Total',
    iva: 'IVA ({{pct}}%)',
    ivaNote: 'Preços sem IVA: acrescenta-se 21% de IVA ao total da reserva. Fatura corporativa conforme.',
    bookNow: 'Reservar agora',
    loginToBook: 'Entre para reservar',
    signInForDetails: 'Entre para ver os detalhes completos.',
    approxLocation: 'Localização aproximada (raio ~700 m)',
    checkin: 'Check-in',
    checkout: 'Check-out',
    tooManyGuests: 'Esta propriedade acomoda até {{capacity}} hóspedes.',
    minStayWarning: 'Estadia mínima: {{count}} noite | Estadia mínima: {{count}} noites',
    nightsWithCount: '{{count}} noite | {{count}} noites',
  },
  booking: {
    title: 'Reservar agora',
    subtitle: 'Verifique os dados do viajante. O valor é recalculado no servidor.',
    confirm: 'Confirmar reserva',
    guestName: 'Nome do viajante',
    guestNamePlaceholder: 'Nome completo',
    guestNif: 'NIF do viajante',
    datesRequired: 'Selecione datas válidas',
    nameRequired: 'Introduza o nome do viajante',
    nifInvalid: 'NIF inválido',
    requestCreated: 'Reserva criada. Pendente de pagamento.',
    notAvailable: 'Essas datas já não estão disponíveis.',
    notApproved: 'A sua conta não está aprovada para reservar.',
    createError: 'Não foi possível criar a reserva. Tente novamente.',
    awaitingDesc: 'Reserva criada. Efetue o pagamento para a confirmar.',
    totalWithIva: 'Total (IVA incluído)',
    priceEstimateNote: 'Preço estimado: o valor final é calculado pela bitutravel ao reservar.',
    total: 'Total',
    reference: 'Referência',
    openPaymentLink: 'Abrir link de pagamento',
    mockDevNote:
      'Modo de desenvolvimento: o pagamento é simulado. Clique para marcar como pago e simular o webhook da Revolut.',
    markPaidDev: 'Marcar como pago (dev)',
    markPaidError: 'Não foi possível simular o pagamento.',
    paid: 'Pagamento confirmado',
    paidDesc: 'A sua reserva está confirmada. Receberá a fatura por email.',
    viewBookings: 'Ver as minhas reservas',
    paymentStatus: 'Pagamento',
    bookingsTitle: 'As minhas reservas',
    browseStays: 'Buscar acomodação',
    summaryTotal: 'Reservas',
    summaryUpcoming: 'Próximas',
    summaryInstay: 'Em estadia',
    summarySpend: 'Gasto total',
    summaryPendingNote: 'Tens {{count}} reservas pendentes de pagamento.',
    payStatusPaid: 'Pago',
    payStatusPending: 'Pendente',
    payStatusAwaiting: 'Aguardando pagamento',
    payStatusRefunded: 'Reembolsado',
    payStatusFailed: 'Falhou',
    payStatusScheduled: 'Programado',
    empty: 'Ainda não tem reservas.',
    statusAwaitingPayment: 'Pendente de pagamento',
    statusConfirmed: 'Confirmada',
    statusActive: 'Em curso',
    statusCompleted: 'Concluída',
    statusCancelled: 'Cancelada',
    statusDisputed: 'Em disputa',
    notFound: 'Reserva não encontrada.',
    viewProperty: 'Ver propriedade',
    cleaningFee: 'Limpeza',
    platformFee: 'Comissão bitutravel',
    cancelBooking: 'Cancelar reserva',
    cancelConfirm: 'Tem a certeza de que quer cancelar esta reserva? Esta ação não pode ser revertida.',
    cancelConfirmYes: 'Sim, cancelar',
    cancelledToast: 'Reserva cancelada.',
    cancelError: 'Não foi possível cancelar a reserva.',
    cancelReason: 'Motivo do cancelamento',
    copyLink: 'Copiar link',
    tabFuture: 'Próximas',
    tabPresent: 'Em curso',
    tabPast: 'Passadas',
    emptyTab: 'Sem reservas nesta secção.',
    purpose: 'Motivo da viagem',
    purposeLeisure: 'Pessoal',
    purposeConference: 'Congresso / evento',
    purposeProject: 'Projeto',
    purposeRelocation: 'Realocação',
    purposeOther: 'Outro',
    eventName: 'Nome do evento',
    eventNamePlaceholder: 'ex. Mobile World Congress 2026',
    teamSize: 'Pessoas',
    teamNotes: 'Detalhes da equipa',
    teamNotesPlaceholder: 'Nomes dos viajantes, quarto, notas…',
    teamDetails: 'Detalhes da viagem / equipa',
    employee: 'Colaborador',
    employeePlaceholder: 'Não atribuído',
    employeeNone: 'Sem colaborador',
    employeeFilterAll: 'Todos os colaboradores',
    employeeCardTitle: 'Colaborador atribuído',
  },
  team: {
    title: 'Equipa',
    addEmployee: 'Adicionar funcionário',
    intro: 'Gerir os funcionários da sua empresa. Atribua-os a reservas para receberem os detalhes por email, ou ative-os para fazerem as suas próprias reservas a cobrar à empresa.',
    featureRosterTitle: 'Lista de funcionários',
    featureRosterDesc: 'Nome, email, telefone e NIF de cada funcionário. A maioria são recorrentes: reutilizáveis em cada reserva.',
    featureEmailTitle: 'Detalhes por email',
    featureEmailDesc: 'Ao reservar, atribua o funcionário e recebe os dados do alojamento por email.',
    featureActivateTitle: 'Ativar para reservar',
    featureActivateDesc: 'Ative um funcionário para entrar com o seu email e reservar em nome da empresa.',
    empty: 'Ainda não há funcionários. Em breve poderá adicioná-los e atribuí-los às suas reservas.',
    editEmployee: 'Editar colaborador',
    editDesc: 'Atualiza os dados de contacto do colaborador.',
    addDesc: 'Adiciona um colaborador e ativa-o para entrar com o seu próprio email.',
    addNote: 'O funcionário é adicionado à lista. Para entrar com o seu email, ative o acesso depois.',
    activateLogin: 'Ativar acesso',
    alreadyActivated: 'Este funcionário já tem acesso ativado.',
    platformUnavailable: 'O serviço não está disponível agora. Tente mais tarde.',
    phone: 'Telefone',
    updated: 'Colaborador atualizado.',
    added: 'Colaborador adicionado.',
    emailExists: 'Já existe um colaborador com esse email.',
    activated: 'Colaborador ativado.',
    deactivated: 'Colaborador desativado.',
    deleted: 'Colaborador eliminado.',
    activate: 'Ativar',
    deactivate: 'Desativar',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar colaborador',
    deleteConfirm: 'Tens a certeza que queres eliminar {{name}}? A conta será removida e não pode ser desfeita.',
    statusActive: 'Ativo',
    statusInactive: 'Inativo',
    statusRoster: 'Apenas lista',
    tempPwTitle: 'Palavra-passe temporária',
    tempPwDesc: 'Esta é a palavra-passe temporária de {{name}}. Partilha-a de forma segura.',
    tempPwWarn: 'Não voltará a ser mostrada. Copia-a agora.',
    copy: 'Copiar',
    copied: 'Copiado',
  },
  agency: {
    title: 'Clientes',
    intro: 'Gere as empresas clientes da tua agência. Adiciona-as com o seu email de faturação e reserva viagens em seu nome — a fatura vai para a empresa cliente.',
    addClient: 'Adicionar empresa cliente',
    clientEmail: 'Email de faturação da empresa',
    clientEmailPlaceholder: 'faturas@empresa.pt',
    addNote: 'A empresa deve ter conta no bitutravel e estar aprovada. É validado ao associar.',
    empty: 'Ainda não tens empresas clientes. Adiciona uma para começar a reservar em seu nome.',
    client: 'Cliente',
    unknownClient: 'Empresa cliente',
    unlinkConfirm: 'Tens a certeza que queres desassociar {{name}}? Já não poderás reservar em seu nome.',
    unlinkedBtn: 'Desassociar',
    unlinked: 'Empresa cliente desassociada.',
    linked: 'Empresa cliente associada: {{name}}.',
    notFound: 'Nenhuma empresa aprovada encontrada com esse email.',
    billTo: 'Reservar para',
    selectClient: 'Seleciona uma empresa cliente',
    noClientsWarn: 'Adiciona primeiro uma empresa cliente em Clientes para poderes reservar.',
  },

  invoices: {
    title: 'Faturas e notas de despesas',
    backToBookings: '← As minhas reservas',
    count: 'Faturas',
    baseTotal: 'Base tributável',
    ivaTotal: 'IVA',
    irpfTotal: 'IRPF retido',
    total: 'Total faturado',
    invoicesTitle: 'Faturas',
    ref: 'Reserva',
    parteTitle: 'Notas de despesas do viajante',
    parteEmpty: 'Ainda não há notas de despesas.',
    empty: 'Ainda não tem faturas. São geradas automaticamente ao confirmar uma reserva.',
    regenTitle: 'Reemitir documentos',
    regenDesc: 'Regenera a fatura e a nota de despesas do viajante de uma reserva (útil para a contabilidade).',
    regenDone: 'Documentos regenerados.',
    regenError: 'Não foi possível regenerar os documentos.',
    downloadError: 'Não foi possível transferir o documento.',
    navInvoices: 'Faturas',
    period30: 'Últimos 30 dias',
    period90: 'Últimos 90 dias',
    period365: 'Últimos 12 meses',
    periodAll: 'Todo o histórico',
    periodEmpty: 'Não há faturas neste período.',
    exportCsv: 'Exportar CSV',
    exportZip: 'Baixar PDFs (ZIP)',
    statusIssued: 'Emitida',
    statusPaid: 'Paga',
    statusVoid: 'Anulada',
  },
  owner: {
    calendar: {
      title: 'Calendário de tarifas',
      subtitle: 'Preço, estadia mínima e disponibilidade noite a noite',
      navButton: 'Tarifas',
      backendRequired: 'Configura o backend do Supabase para usar o calendário de tarifas.',
      basePrice: 'Tarifa base',
      cleaningFee: 'Limpeza',
      applyTitle: 'Aplicar à seleção',
      clearSelection: 'Limpar seleção',
      selectHint: 'Clique numa noite e depois noutra para escolher um intervalo. Cada célula é uma noite — a última marcada é a noite anterior ao check-out.',
      selectedNights: '{{count}} noite selecionada | {{count}} noites selecionadas',
      skipped: '{{count}} noite ignorada (reservada ou passada) | {{count}} noites ignoradas (reservadas ou passadas)',
      noneEditable: 'Todas as noites selecionadas estão reservadas ou já passaram.',
      priceLabel: 'Novo preço (€)',
      pricePlaceholder: '€ / noite',
      minNightsLabel: 'Estadia mínima (noites)',
      minNightsPlaceholder: 'ex. 5',
      applyPrice: 'Definir preço',
      applyMinNights: 'Definir mínimo',
      block: 'Bloquear',
      unblock: 'Abrir',
      removeOverride: 'Remover personalização',
      blockNameLabel: 'Nome do bloqueio',
      blockNamePlaceholder: 'ex. Manutenção, Obra…',
      saved: 'Calendário atualizado',
      saveError: 'Não foi possível guardar o calendário.',
      legend: {
        available: 'Disponível',
        priced: 'Preço personalizado',
        blocked: 'Bloqueada',
        booked: 'Reservada',
        past: 'Passada',
        sunday: 'Domingo',
      },
      ical: {
        title: 'Exportar calendário (iCal)',
        desc: 'Liga este feed ao Airbnb, Booking.com ou ao teu channel manager para sincronizar as reservas.',
        copy: 'Copiar',
        copied: 'Link copiado',
        unavailable: 'Feed não disponível para esta propriedade.',
      },
      bulk: {
        from: 'De',
        to: 'até',
        allDays: 'Todos os dias',
        weekdays: 'Dias úteis',
        weekends: 'Fim de semana',
        allYear: 'O ano todo',
        pickDay: 'Escolha pelo menos um dia da semana',
      },
    },
    revenueTitle: 'Receitas',
    invoicesTitle: 'Faturas e recebimentos',
    invoicesNote: 'As faturas são geradas automaticamente ao confirmar uma reserva; os pagamentos são liquidados conforme o calendário bitutravel.',
    gross: 'Base (sem IVA)',
    fee: 'Comissão bitutravel',
    iva: 'IVA',
    net: 'Receita líquida',
    paidOut: 'Pago',
    pending: 'Pendente de pagamento',
    monthlyTitle: 'Receitas por mês',
    perPropertyTitle: 'Por propriedade',
    property: 'Propriedade',
    bookings: 'Reservas',
    nights: 'Noites',
    payoutsTitle: 'Pagamentos ao proprietário',
    eligibleDesc: 'Reservas confirmadas prontas a pagar:',
    payNow: 'Pagar',
    scheduled: 'Programado',
    noPayouts: 'Ainda não há pagamentos.',
    noData: 'Ainda sem dados.',
    payoutDone: 'Pagamento emitido.',
    payoutError: 'Não foi possível emitir o pagamento.',
    range7: '7 d',
    range15: '15 d',
    range30: '30 d',
    range90: '90 d',
    range12m: '12 m',
    rangeAll: 'Tudo',
    payoutConfirmTitle: 'Confirmar pagamento',
    payoutConfirmDesc: 'Emitir o pagamento da reserva #{{id}} no valor de {{amount}}?',
    confirm: 'Confirmar',
    propertiesNav: 'Calendário',
    propertiesTitle: 'Calendário',
    newProperty: 'Adicionar propriedade',
    editProperty: 'Editar',
    propertyUntitled: 'Propriedade sem título',
    propertiesEmpty: 'Ainda não publicou nenhuma propriedade.',
    pendingReviewNote: 'As novas propriedades ficam em revisão até serem aprovadas pela equipa da bitutravel. Avisaremos por email.',
    pendingEditorNote: 'Esta propriedade está em revisão. Poderá editá-la; aparecerá na pesquisa quando for aprovada.',
    unpublished: 'Não publicada',
    photoCount: '{{count}} fotos',
    noPhotos: 'Sem fotos',
    unitCount: '{{count}} unidades',
    viewCalendar: 'Calendário',
    viewList: 'Lista',
    searchUnits: 'Procurar unidades…',
    sortName: 'Nome',
    sortRecent: 'Recentes',
    chipNeedsPhotos: 'Sem fotos',
    stripNoBookings: 'Sem reservas nos próximos 30 dias',
    pms: {
      title: 'Gestor de reservas',
      subtitle: 'Reservas por unidade — arraste para mover',
      prev: 'Anterior',
      next: 'Seguinte',
      today: 'Hoje',
      view_month: 'Mês',
      view_week: 'Semana',
      dragHint: 'Arraste uma reserva para outra unidade ou data para movê-la.',
      moved: 'Reserva movida',
      moveError: 'Não foi possível mover a reserva',
      noCity: 'Sem cidade',
      cities: 'Cidades',
      properties: 'Propriedades',
      unit: 'Unidade',
      overall: 'Vista geral',
      allProperties: 'Todas as propriedades',
      noUnits: 'Ainda não tem unidades. Adicione uma propriedade para começar.',
      guest: 'Hóspede',
      dragHintBlocked: "Click an empty day to block / open it. Drag a booking to move it; drag its right edge to extend or shorten.",
      addBooking: "Add booking",
      dates: 'Datas',
      autoRate: 'Tarifa automática',
      applyCustomPrice: 'Aplicar preço personalizado (desconto)',
      customPriceHint: 'Edita o total para aplicar um desconto. É repartido pelas noites.',
      manualBooking: "Manual booking",
      manualBadge: "Manual",
      guestName: "Guest name",
      guestNif: "Guest NIF",
      guests: "Guests",
      pricePerNight: "Preço por noite",
      checkin: "Check-in",
      checkout: "Check-out",
      block: "Block",
      unblock: "Open",
      blocked: "Blocked",
      blockTitle: 'Bloquear noite',
      blockNameLabel: 'Nome (opcional)',
      blockNamePlaceholder: 'ex. Manutenção',
      blockNameHint: 'Será mostrado no dia bloqueado.',
      blockConfirm: 'Bloquear',
      manualCreated: "Manual booking created",
      manualError: "Could not create manual booking",
      notAvailable: "Not available for those dates",
      belowMinStay: "Below the minimum stay for this unit",
      detail: "Booking detail",
      property: "Property",
      nights: "Nights",
      total: "Total",
      iva: "VAT",
      fee: "Platform fee",
      payout: "Payout",
      channel: "Channel",
      status: "Status",
      statusConfirmed: "Confirmed",
      statusActive: "In stay",
      statusPending: "Pending",
      statusAwaiting: "Awaiting payment",
      statusCancelled: "Cancelled",
      channelManual: "Manual",
      channelDirect: "Direct",
      channelIcal: "iCal (importado)",
      icalNoPayout: "Bloqueio externo — sem pagamento",
      confirmMove: "Confirm move",
      moveFrom: "From",
      moveTo: "To",
      moveNote: "Availability and price are revalidated on confirm.",
      confirm: "Confirm",
      extendTitle: "Extend stay",
      shortenTitle: "Shorten stay",
      newCheckout: "New check-out",
      extended: "Stay updated",
      extendError: "Could not update the stay",
    },
    products: {
      nav: 'Propriedades',
      title: 'Propriedades',
      subtitle: 'Tarifas e canais por unidade. A tarifa padrão sincroniza com o preço da propriedade.',
      empty: 'Ainda não tem propriedades.',
      ratePlans: 'Tarifas',
      addRatePlan: 'Adicionar tarifa',
      editRatePlan: 'Editar tarifa',
      ratePlanDesc: 'Uma tarifa é uma oferta vendável desta unidade (preço, limpeza, estadia mínima).',
      noPlans: 'Sem tarifas ainda.',
      planCount: '{{count}} tarifas',
      icalCount: '{{count}} iCal',
      default: 'Padrão',
      inactive: 'Inativa',
      minNights: 'mín. {{count}} noites',
      minNightsLabel: 'Noites mínimas',
      feePct: 'comissão {{pct}}%',
      feePctLabel: 'Comissão bitutravel (%)',
      feePctPlaceholder: 'padrão',
      feePctHint: 'Vazio = comissão global. 0 = cliente próprio (sem comissão).',
      makeDefault: 'Tarifa padrão',
      name: 'Nome',
      basePrice: 'Preço base (NET)',
      cleaningFee: 'Limpeza',
      cancellation: 'Cancelamento',
      policy: {
        flexible: 'Flexível',
        moderate: 'Moderada',
        strict: 'Rígida',
      },
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Eliminar',
      confirmDelete: 'Eliminar?',
      defaultNoDelete: 'A tarifa padrão não pode ser eliminada.',
      created: 'Tarifa criada.',
      updated: 'Tarifa atualizada.',
      deleted: 'Tarifa eliminada.',
      channels: 'Canais',
      addChannel: 'Adicionar canal',
      direct: 'Direto',
      noConnections: 'Sem conexões. Adicione um canal iCal para importar um calendário externo.',
      icalChannel: 'iCal',
      addIcal: 'Adicionar conexão iCal',
      icalDesc: 'Cole o URL iCal de um calendário externo (Airbnb, Booking, Google…). As datas reservadas bloquearão esta unidade.',
      icalUrl: 'URL do calendário iCal',
      addAndSync: 'Adicionar e sincronizar',
      syncNow: 'Sincronizar',
      syncAll: 'Sincronizar tudo',
      syncDone: '{{upserted}} importadas, {{cancelled}} canceladas, {{conflicts}} conflitos',
      syncAllDone: 'Sincronização completa: {{upserted}} importadas, {{cancelled}} canceladas, {{conflicts}} conflitos',
      syncError: 'Erro de sincronização',
      lastSync: 'Última sincronização',
      neverSynced: 'Ainda não sincronizado',
      connectionDeleted: 'Conexão eliminada.',
      connStatus: {
        pending: 'Pendente',
        active: 'Ativa',
        paused: 'Pausada',
        error: 'Erro',
      },
      rangeActionTitle: 'Intervalo selecionado',
      rangeActionHint: 'O que queres fazer com estas noites?',
      selectHint: 'Clica numa noite e depois noutra (ou duas vezes na mesma) para escolher um intervalo.',
    },

    status: {
      pending: 'Em revisão',
      approved: 'Publicado',
      rejected: 'Recusada',
    },
    step1: 'Dados',
    step2: 'Descrição',
    step3: 'Localização e fotos',
    backStep: 'Voltar',
    nextStep: 'Seguinte',
    saveProperty: 'Guardar propriedade',
    fieldType: 'Tipo de alojamento',
    type: {
      apartment: 'Apartamento',
      studio: 'Estúdio',
      house: 'Casa',
      room: 'Quarto',
      loft: 'Loft',
      duplex: 'Duplex',
      cabin: 'Cabana',
      guesthouse: 'Pensão',
      hotel: 'Hotel',
      bed_breakfast: 'Cama e pequeno-almoço',
    },
    fieldCapacity: 'Capacidade (hóspedes)',
    fieldBeds: 'Camas',
    fieldPrice: 'Preço por noite (€)',
    fieldCleaning: 'Taxa de limpeza (€)',
    fieldCheckinTime: 'Horário de check-in',
    fieldCheckoutTime: 'Horário de check-out',
    fieldTitleEs: 'Título (espanhol)',
    fieldTitleEn: 'Título (inglês)',
    fieldDescEs: 'Descrição (espanhol)',
    fieldDescEn: 'Descrição (inglês)',
    fieldCity: 'Cidade',
    fieldCategory: 'Categoria',
    fieldCategoryHint: 'executive, standard, suite…',
    fieldBuilding: 'Edifício / endereço',
    fieldUnitLabel: 'Etiqueta da unidade',
    fieldNeighborhood: 'Bairro / distrito',
    fieldNeighborhoodHint: 'ex. Chamberí',
    fieldPostalCode: 'Código postal',
    cityPrefillNote: 'Ao escolher a cidade, preenchemos as coordenadas com o centro; ajuste-as se souber a localização exata.',
    photosAfterCreate: 'Guarde a propriedade para poder adicionar fotos.',
    addPhotos: 'Adicionar fotos',
    deletePhoto: 'Eliminar foto',
    photoUploadError: 'Não foi possível carregar a foto.',
    photoDeleteError: 'Não foi possível eliminar a foto.',
    createdToast: 'Propriedade criada. Está em revisão.',
    savedToast: 'Propriedade guardada.',
    saveError: 'Não foi possível guardar a propriedade.',
    fiscal: {
      title: 'Dados fiscais & VeriFactu',
      subtitle: 'Dados do emitente e autorização para a bitutravel remeter as suas faturas à AEAT.',
      statusActive: 'VeriFactu ativo. As suas faturas de alojamento são remetidas à AEAT.',
      statusPending: 'VeriFactu pendente. As suas faturas são emitidas mas não remetidas à AEAT.',
      statusRevoked: 'A sua autorização foi revogada. A remissão à AEAT está pausada.',
      active: 'Ativo',
      pending: 'Pendente',
      revoked: 'Revogado',
      issuerTitle: 'Dados do emitente',
      personaType: 'Tipo de pessoa',
      personaF: 'Física',
      personaJ: 'Jurídica',
      seriesLodging: 'Série de faturas',
      seriesHint: 'Série AEAT para as suas faturas de alojamento (predefinição O). Não a altere sem motivo.',
      legalName: 'Razão social / Nome',
      nif: 'NIF',
      country: 'País',
      street: 'Endereço',
      postalCode: 'Código postal',
      city: 'Localidade',
      save: 'Guardar dados fiscais',
      saved: 'Dados fiscais guardados.',
      saveError: 'Não foi possível guardar os dados fiscais.',
      errFields: 'Razão social e NIF são obrigatórios.',
      apoderamientoTitle: 'Procuração',
      apoderamientoDesc: 'Para remeter faturas à AEAT em seu nome, a bitutravel precisa de uma procuração assinada. Carregue a procuração assinada para ativar a remissão.',
      poderOnFile: 'Procuração registada:',
      uploadPoder: 'Carregar procuração assinada (PDF)',
      poderHint: 'PDF, máx. 10 MB.',
      granted: 'Procuração ativada. O VeriFactu remeterá as suas próximas faturas.',
      grantError: 'Não foi possível registar a procuração.',
      errPoderSize: 'O ficheiro excede os 10 MB.',
      legalNote: 'Ao carregar a procuração confirma que assinou a autorização de representação para a bitutravel remeter faturas à AEAT (RD 1007/2023).',
      bannerPending: 'Ative o VeriFactu para remeter as suas faturas à AEAT.',
      bannerRevoked: 'A sua autorização VeriFactu está revogada.',
      bannerCta: 'Configurar',
    },

  },
  profile: {
    title: 'Perfil e definições',
    navProfile: 'Perfil',
    accountSection: 'Conta',
    statusLabel: 'Estado da conta',
    rejectionReason: 'Motivo da recusa',
    detailsSection: 'Dados fiscais',
    languageSection: 'Idioma',
    localeLabel: 'Idioma preferido',
    localeHint: 'É guardado na sua conta e aplicado em todos os seus dispositivos.',
    localeSaved: 'Idioma atualizado.',
    billingSection: 'Faturação e pagamento',
    invoiceEmail: 'Email de faturação',
    invoiceEmailPlaceholder: 'faturas@empresa.pt',
    ibanTransfer: 'IBAN (pagamento por transferência)',
    ibanHint: 'Se preferir pagar por transferência bancária.',
    preferredMethod: 'Método de pagamento preferido',
    methodCard: 'Cartão',
    methodTransfer: 'Transferência',
    savedCards: 'Cartões guardados',
    defaultCard: 'Predefinido',
    billingProcessorNote: 'Os dados do cartão são tokenizados com a Revolut; nunca armazenamos o número completo.',
    billingSaved: 'Faturação atualizada.',
  },
  auth: {
    registerTitle: 'Criar conta',
    loginTitle: 'Entrar',
    rolePrompt: 'Como vai usar o bitutravel?',
    roleBook: 'Reservo estadias',
    roleList: 'Publico propriedades',
    roleCompany: 'Empresa',
    roleAutonomo: 'Independente',
    roleOwner: 'Proprietário',
    roleEmployeeLabel: 'Funcionário',
    roleAgencyLabel: 'Agência',
    roleCompanyDesc: 'Reservas centralizadas para a sua empresa',
    roleAutonomoDesc: 'Para profissionais independentes',
    roleOwnerDesc: 'Para publicar e rentabilizar as suas propriedades',
    roleBookerPrompt: 'Quem reserva?',
    pathManager: 'Gestiono propriedades',
    pathManagerDesc: 'Publique o seu inventário e gerencie tarifas e disponibilidade',
    pathBook: 'Reservo estadias',
    pathBookDesc: 'Para empresas, funcionários e autônomos que se hospedam',
    roleEmployee: 'Trabalho numa empresa',
    roleEmployeeDesc: 'Reservo com o cartão da minha empresa; a fatura vai para ela',
    contactName: 'Pessoa de contato',
    email: 'Email',
    fullName: 'Nome completo',
    legalName: 'Nome da empresa',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Morada',
    iban: 'IBAN para recebimentos',
    irpf: 'Retenção IRPF (%)',
    submit: 'Enviar pedido',
    pendingTitle: 'Pedido em revisão',
    pendingDesc: 'A nossa equipa está a verificar a sua conta. Avisaremos por email quando for aprovada.',
    pendingApproved: 'A sua conta foi aprovada!',
    checkStatus: 'Verificar novamente',
    profileErrorTitle: 'Não foi possível carregar o seu perfil',
    profileErrorDesc:
      'A sua sessão é válida mas não encontramos os dados da sua conta. Tente novamente ou saia.',
    rejectedTitle: 'Pedido recusado',
    rejectedDesc: 'O seu pedido não foi aprovado. Motivo: {{reason}}',
    loginPrompt: 'Já tem conta? Entre',
    registerPrompt: 'Não tem conta? Registe-se',
    login: 'Entrar',
    magicLink: 'Enviar ligação mágica',
    magicLinkSent:
      'Enviámos uma ligação mágica para o seu email. Abra-a para entrar.',
    cifInvalid: 'CIF inválido',
    cifInRegistry: 'Encontrada no diretório',
    nifOrCifInvalid: 'NIF/CIF inválido',
    ibanInvalid: 'IBAN inválido',
    irpfRange: 'Deve estar entre 7 e 45 %',
    loginErrorGeneric: 'Não foi possível entrar. Verifique o email.',
    loginRateLimited: 'Demasiadas tentativas. Aguarde um minuto.',
    loginEmailNotConfirmed: 'Confirme o seu email antes de entrar.',
  },
  admin: {
    approvalsTitle: 'Fila de aprovações',
    approve: 'Aprovar',
    reject: 'Recusar',
    reason: 'Motivo',
    empty: 'Sem pedidos pendentes',
    typeCompany: 'Empresa',
    typeAutonomo: 'Independente',
    typeOwner: 'Proprietário',
    approvedToast: 'Pedido aprovado',
    rejectedToast: 'Pedido recusado',
    decisionFailed: 'Não foi possível guardar a decisão',
    searchPlaceholder: 'Pesquisar por nome, email ou NIF/CIF',
    tabAll: 'Todos',
    tabCompany: 'Empresas',
    tabAutonomo: 'Independentes',
    tabOwner: 'Proprietários',
    confirmApprove: 'Aprovar {{name}}?',
    confirmReject: 'Recusar {{name}}?',
    confirm: 'Confirmar',
    reasonRequired: 'Indique o motivo da recusa',
    noMatches: 'Sem resultados',
    roleAdmin: 'Administração',
    consoleTitle: 'Consola de administração',
    navApprovals: 'Aprovações',
    navAccounts: 'Contas',
    navBookings: 'Reservas',
    navInvoices: 'Faturas',
    tabAgency: 'Agências',
    tabEmployee: 'Colaboradores',
    tabBlocked: 'Bloqueados',
    typeAgency: 'Agência',
    typeEmployee: 'Colaborador',
    typeAdmin: 'Admin',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Pendente',
    active: 'Ativo',
    blocked: 'Bloqueado',
    rejected: 'Rejeitado',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    blockedToast: 'Conta bloqueada',
    unblockedToast: 'Conta desbloqueada',
    manageFailed: 'Não foi possível alterar o estado da conta',
    commissionDefault: 'Padrão {{pct}}%',
    commissionEdit: 'Editar',
    commissionSave: 'Guardar',
    commissionCancel: 'Cancelar',
    commissionSaved: 'Comissão atualizada.',
    commissionFailed: 'Não foi possível atualizar a comissão.',
    lastActions: '{{count}} ações de administração registadas',
    noBookings: 'Sem reservas.',
    noInvoices: 'Sem faturas.',
    kindCommission: 'Comissão',
    kindLodging: 'Alojamento',
    vfFiled: 'VeriFactu remetida',
    vfIncidence: 'Incidência',
    vfPending: 'VeriFactu pendente',
    navRegistry: 'Diretório',
    vfSubmit: 'Enviar para AEAT',
    vfSubmitted: 'Enviada para AEAT',
    vfSubmitFailed: 'Falha ao enviar para AEAT',
    vfNotConfigured: 'Certificado VeriFactu não configurado',
    void: 'Anular',
    voidConfirm: 'Anular esta fatura? Se foi enviada à AEAT, será enviado um cancelamento.',
    voidDone: 'Fatura anulada',
    voidFailed: 'Não foi possível anular a fatura',
    voidAnulacionPending: 'Cancelamento AEAT pendente de certificado',
    voided: 'Anulada',
    rect: 'Retificadora',
    rectConfirm: 'Emitir uma retificadora que substitua esta fatura?',
    rectDone: 'Retificadora emitida',
    rectFailed: 'Não foi possível emitir a retificadora',
    registry: {
      addTitle: 'Adicionar empresa',
      editTitle: 'Editar empresa',
      listTitle: 'Diretório de empresas',
      cif: 'CIF',
      legalName: 'Razão social',
      street: 'Rua',
      postalCode: 'Código postal',
      city: 'Cidade',
      province: 'Província',
      country: 'País',
      save: 'Guardar',
      saved: 'Empresa guardada',
      saveError: 'Não foi possível guardar a empresa',
      deleted: 'Empresa removida',
      deleteError: 'Não foi possível remover a empresa',
      errFields: 'CIF e razão social são obrigatórios',
      empty: 'Ainda não há empresas no diretório',
      edit: 'Editar',
    },
  },
  dashboard: {
    roleLabel: 'Função',
    emailLabel: 'Email',
  },
  notFound: {
    title: 'Página não encontrada',
    desc: 'A página que procura não existe ou mudou de endereço.',
  },
  error: {
    boundaryDesc: 'Algo correu mal. Recarregue para continuar.',
    boundaryReload: 'Recarregar',
  },
  common: {
    loading: 'A carregar…',
    error: 'Algo correu mal',
    favorite: 'Guardar nos favoritos',
    required: 'Obrigatório',
    back: 'Voltar',
    retry: 'Tentar novamente',
    continue: 'Continuar',
    done: 'Concluído',
    save: 'Guardar',
    plusIva: '+ IVA',
    cancel: 'Cancelar',
    rooms: 'quartos',
    room: 'quarto',
    bathrooms: 'casas de banho',
    bathroom: 'casa de banho',
    increment: 'Aumentar',
    decrement: 'Reduzir',
    edit: 'Editar',
    close: "Fechar",
    previous: 'Anterior',
    next: 'Próximo',
  },
  amenities: {
    wifi: 'Wi-Fi',
    parking: 'Estacionamento',
    ac: 'Ar condicionado',
    heating: 'Aquecimento',
    washing: 'Máquina de lavar',
    dishwasher: 'Máquina de lavar louça',
    elevator: 'Elevador',
    furnished: 'Mobilado',
    kitchen: 'Cozinha',
    meeting_room: 'Sala de reuniões',
    printer: 'Impressora',
    gym: 'Ginásio',
  },
} as const